var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApricLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 223,
    viewBox: "0 0 223 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.42 160.581C147.901 160.581 150.368 160.643 152.82 160.761C139.902 156.258 125.999 153.788 111.5 153.788C62.2254 153.788 19.7097 182.112 0 223.031H23.5257C50.3164 185.29 94.9162 160.577 145.416 160.577L145.42 160.581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.689 223.019H223C209.089 194.137 183.809 171.549 152.82 160.745C150.369 160.628 147.902 160.565 145.421 160.565C127.034 160.565 109.435 163.854 93.1851 169.843C95.0669 169.773 96.9599 169.725 98.8604 169.725C145.151 169.725 186.486 190.49 213.692 223.016L213.689 223.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5322 223.043H44.4864C60.0952 203.574 84.3219 191.031 111.506 191.031C138.69 191.031 162.917 203.574 178.526 223.043H213.694C186.492 190.513 145.157 169.753 98.8624 169.753C96.9619 169.753 95.0727 169.801 93.1872 169.87C64.8109 180.329 40.5655 199.046 23.5285 223.047L23.5322 223.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.363 148.317L147.23 154.706C172.256 161.924 194.612 176.564 211.004 196.539L156.8 78.3176C157.04 81.7269 157.171 85.1619 157.171 88.6299C157.171 109.867 152.591 130.059 144.359 148.317H144.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2658 78.6351L12.0848 196.438C28.4808 176.503 50.8219 161.897 75.8245 154.697L78.7072 148.296C69.1335 127.07 64.549 103.337 66.2658 78.6351V78.6351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4605 13L66.2736 78.6319C64.5568 103.334 69.1413 127.067 78.715 148.293L86.4219 131.181L111.548 77.1419V13H96.4605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.638 13L156.825 78.6319C158.541 103.334 153.957 127.067 144.383 148.293L136.676 131.181L111.55 77.1419V13H126.638Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 223,
    height: 223,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApricLogo);
export default __webpack_public_path__ + "static/media/apric-logo.65c15b19b0f76774a2c3b8d8aab30548.svg";
export { ForwardRef as ReactComponent };